export enum PanelsName {
    notificationPanel = 'notificationsPanel',
    reportPanel = 'reportsPanel',
}